<template>
  <div class="editpassword">
    <el-col class="userinfoList infoPub"  style="width: 990px">
      <div class="editpasswordCon">
        <el-form
          :model="ruleForm"
          status-icon
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
         <el-form-item :label="language.originalPassword+':'" :label-width="formLabelWidth">
            <el-input type="password" v-model="ruleForm.oldpass" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item :label="language.newPassword+':'" prop="pass" :label-width="formLabelWidth">
            <el-input type="password" v-model="ruleForm.pass" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item :label="language.confirmPassword+':'" prop="checkPass" :label-width="formLabelWidth">
            <el-input type="password" v-model="ruleForm.checkPass" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item>
            <el-tooltip class="item" effect="dark" :content="language.savePwdnotes" placement="top">
              <el-button class="saveBtn" type="primary" @click="submitForm('ruleForm')">{{language.save}}</el-button>
              <!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
              </el-tooltip>
          </el-form-item>
        </el-form>
      </div>
    </el-col>
  </div>
</template>
<script>
import { editPassword } from "../../../api/btManage";
import { language } from "../../../language/get";
 import store from "../../../store";
 import Cookie from "../../../common/cookie"
 const pubLanguage = language()
import {isPassword} from "../../../common/validate";

export default {
  data() {
    var oldvalidatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(pubLanguage.enterOriginalPassword));
      } else {
        if (this.ruleForm.pass !== "") {
          this.$refs.ruleForm.validateField("pass");
        }
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(pubLanguage.enterYourPassword));
      }else if (value == this.ruleForm.oldpass) {
        callback(new Error(pubLanguage.samePassword));
      } else {
        if (this.ruleForm.checkPass !== "") {
          this.$refs.ruleForm.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(pubLanguage.passwordAgain));
      } else if (value !== this.ruleForm.pass) {
        callback(new Error(pubLanguage.twoPassinconsistent));
      } else {
        callback();
      }
    };
    return {
      language:language(),
      lan: Cookie.get("lang"),
      formLabelWidth:Cookie.get("lang") == 'ch'?'74px':'140px',
      ruleForm: {
        oldpass:"",
        pass: "",
        checkPass: "",
      },
      token:this.$store.state.user.token,
      // rules: {
      //   pass: [{ validator: isPassword, trigger: "blur" }],
      //   checkPass: [{ validator: validatePass2, trigger: "blur" }],
      // }
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {

        if (!this.ruleForm.oldpass||!this.ruleForm.checkPass||!this.ruleForm.pass) {
          this.$message.error({message: this.language.completeInfo, offset: 120})
          return false;
        }else if (this.ruleForm.checkPass!=this.ruleForm.pass) {
          this.$message.error({message: this.language.checkPassMistake, offset: 120})
          return false;
        }else if (this.ruleForm.oldpass.length<6||this.ruleForm.pass<6) {
          this.$message.error({message: this.language.passMistake, offset: 120})
          return false;
        }
        if (valid) {
          let data = {
              token:this.token,
              password:this.ruleForm.oldpass,
              newpassword:this.ruleForm.pass,
          }
          editPassword(data).then(res=>{
              if (res.type == "1") {
            this.$message({
              showClose: true,
              message: this.language.editSuccess,
              type: "success",
              offset: "100"
            });
            store.dispatch("Logout", {token:this.token}).then(res => {
            window.location = "login.html";
          })
          }else{
                if (this.lan == "ch") {
                  return this.$message.error({message: res.text, offset: 120})
                }
                return this.$message.error({message: res.text_en, offset: 120})
          }
          })
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};
</script>
<style>
.editpasswordCon {
  height: 550px;
  background: #ffffff;
  display: flex;
  justify-content: center;
  padding-top:53px;
  box-sizing: border-box
}
.editpasswordCon input{
    width: 300px;
    height: 40px;
    background: #F2F2F2
}
.editpasswordCon .el-form-item__label{
    text-align: left
}
.editpasswordCon .saveBtn{
    width: 201px;
    height: 41px;
    border-radius: 10px;
    background: #FF8800;
    color: #ffffff;
    border:none;
    margin-top: 71px
}
.editpasswordCon .el-form-item {
  margin-bottom: 40px;
}
</style>
